import { render, staticRenderFns } from "./Starter.vue?vue&type=template&id=4a4f6906"
import script from "./Starter.js?vue&type=script&lang=js&external"
export * from "./Starter.js?vue&type=script&lang=js&external"
import style0 from "./Starter.vue?vue&type=style&index=0&id=4a4f6906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports